import { useState } from "react";
import { Link } from "react-router-dom";
import { faqs } from "@/mocks/faq";
import { useDocumentTitle } from "@/hooks/useDocumentTitle";

export default function FaqPage() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  useDocumentTitle(
    "常见问题 - 91免费影视",
    "关于 91免费影视 的常见问题解答，包括平台定位、播放说明、收藏功能、筛选搜索与手机端使用等。",
  );

  return (
    <div className="w-full">
      <section className="bg-primary-800">
        <div className="mx-auto w-full px-4 py-12 md:px-6 md:py-16">
          <nav className="flex items-center gap-1.5 text-sm text-background-300">
            <Link to="/" className="transition-colors hover:text-accent-300">
              首页
            </Link>
            <i className="ri-arrow-right-s-line" />
            <span className="font-medium text-background-100">常见问题</span>
          </nav>
          <h1 className="mt-5 font-heading text-3xl font-bold text-background-50 md:text-4xl">常见问题</h1>
          <p className="mt-3 max-w-2xl text-sm leading-relaxed text-background-200 md:text-base">
            这里整理了用户在使用 91 免费影视平台时最常遇到的问题。如果没有找到答案，欢迎前往关于我们页面留言。
          </p>
        </div>
      </section>

      <div className="mx-auto w-full px-4 py-12 md:px-6 md:py-16">
        <div className="mx-auto max-w-3xl">
          <div className="space-y-3">
            {faqs.map((item, index) => {
              const open = openIndex === index;
              return (
                <div
                  key={item.q}
                  className="overflow-hidden rounded-lg bg-background-50 ring-1 ring-background-200 transition-colors"
                >
                  <button
                    type="button"
                    onClick={() => setOpenIndex(open ? null : index)}
                    aria-expanded={open}
                    className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                  >
                    <span className="flex items-start gap-3">
                      <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-md bg-primary-500 text-xs font-bold text-background-50">
                        Q
                      </span>
                      <span className="font-heading text-sm font-bold text-foreground-900 md:text-base">
                        {item.q}
                      </span>
                    </span>
                    <i
                      className={`shrink-0 text-xl transition-transform ${
                        open ? "rotate-45 text-accent-600" : "text-foreground-400"
                      } ri-add-line`}
                    />
                  </button>
                  {open && (
                    <div className="border-t border-background-200 px-5 pb-5 pt-4">
                      <div className="flex items-start gap-3">
                        <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-md bg-secondary-200 text-xs font-bold text-foreground-700">
                          A
                        </span>
                        <p className="text-sm leading-loose text-foreground-700">{item.a}</p>
                      </div>
                    </div>
                  )}
                </div>
              );
            })}
          </div>

          <div className="mt-10 flex flex-col items-center rounded-lg bg-primary-50 px-6 py-10 text-center ring-1 ring-primary-100">
            <span className="flex h-14 w-14 items-center justify-center rounded-full bg-primary-500 text-2xl text-background-50">
              <i className="ri-question-answer-line" />
            </span>
            <h3 className="mt-4 font-heading text-lg font-bold text-foreground-900">还有其他疑问？</h3>
            <p className="mt-2 max-w-md text-sm text-foreground-600">
              前往“关于我们”页面填写反馈表单，我们会尽快回复你的问题。
            </p>
            <Link
              to="/about"
              className="mt-6 flex items-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-6 py-2.5 text-sm font-bold text-primary-950 transition-colors hover:bg-accent-400"
            >
              <i className="ri-chat-smile-2-line" />
              联系与反馈
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}